import module from './home.module';

module.controller('HomeController', [
  'CurrentUserService',
  function (CurrentUserService) {
    var ctrl = this;
    ctrl.selfId = CurrentUserService.currentUser.id;
  },
]);
